import React from 'react';
import {
  Alert, Box, Button, Chip, CircularProgress, Grid, Paper, Stack,
  TextField, Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

import { fetchTaskProgress } from './taskprogress.apis';
import { ITaskProgress } from './taskprogress.models';
import TaskProgressCard from './TaskProgressCard';

import ProgressApprovalPanel from './ProgressApprovalPanel';
import ProgressEvidencePanel from './ProgressEvidencePanel';

import { fetchTaskPlanning } from './taskprogress.apis';

import TaskProgressStatsBar from './TaskProgressStatsBar';
import TaskActionTimeline from './TaskActionTimeline';
import TaskInspector from './TaskInspector';

type State = {
  loading: boolean;
  error: string;
  rows: ITaskProgress[];
  selected?: ITaskProgress;
  search: string;
  inspectorTab: number;
};

export default class TaskProgressWorkbench extends React.PureComponent<any, State> {
  state: State = {
    loading: false,
    error: '',
    rows: [],
    search: '',
    inspectorTab: 0,
  };

  componentDidMount() {
    this.load();
  }

  // load = async () => {
  //   this.setState({ loading: true, error: '' });
  //   try {
  //     const rows = await fetchTaskProgress({
  //       status: 1,
  //       search: this.state.search || undefined,
  //       pageoffset: 0,
  //       pagelimit: 100,
  //     });

  //     this.setState({
  //       rows,
  //       selected: rows[0],
  //       loading: false,
  //     });
  //   } catch (e: any) {
  //     this.setState({
  //       loading: false,
  //       error: e?.message || 'Unable to load task progress.',
  //     });
  //   }
  // };

  load = async () => {
    this.setState({ loading: true, error: '' });

    try {
      const params = {
        status: 1,
        search: this.state.search || undefined,
        pageoffset: 0,
        pagelimit: 200,
      };

      const planned = await fetchTaskPlanning(params);
      const progress = await fetchTaskProgress(params);

      const progressMap = new Map<string, any>();
      progress.forEach((r: any) => {
        progressMap.set(`${r.api}-${r.tki}`, r);
      });

      const merged = planned.map((p: any) => {
        const existing = progressMap.get(`${p.api}-${p.tki}`);
        return existing ? { ...p, ...existing, isplanned: false } : p;
      });

      this.setState({
        rows: merged,
        selected: merged[0],
        loading: false,
      });
    } catch (e: any) {
      this.setState({
        loading: false,
        error: e?.message || 'Unable to load task progress.',
      });
    }
  };

  select = (row: ITaskProgress, tab = 0) => {
    this.setState({
      selected: row,
      inspectorTab: tab,
    });
  };

  render() {
    const { loading, error, rows, selected, search } = this.state;

    return (
      <Box>
        <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h6">Execution Workbench</Typography>
              <Typography variant="body2" color="text.secondary">
                Monitor task progress, approvals, and supporting evidence.
              </Typography>
            </Box>

            <TextField
              size="small"
              label="Search task/activity"
              value={search}
              onChange={(e) => this.setState({ search: e.target.value })}
              onKeyDown={(e) => {
                if (e.key === 'Enter') this.load();
              }}
            />

            <Button
              variant="contained"
              startIcon={loading ? <CircularProgress size={16} /> : <RefreshIcon />}
              onClick={this.load}
              disabled={loading}
            >
              Refresh
            </Button>
          </Stack>
        </Paper>

        <TaskProgressStatsBar rows={rows} />

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Grid container spacing={2}>
          <Grid size = {{ xs:12, md:7}}>
            <Stack spacing={1.5}>
              {rows.map((r) => (
                // <TaskProgressCard
                //   key={`${r.rid}-${r.tki}`}
                //   row={r}
                //   selected={selected?.rid === r.rid}
                //   onSelect={this.select}
                //   onChanged={this.load}
                // />
                <TaskProgressCard
                  key={`${r.rid || 'planned'}-${r.api}-${r.tki}`}
                  row={r}
                  selected={selected?.api === r.api && selected?.tki === r.tki}
                  onSelect={this.select}
                  onChanged={this.load}
                />
              ))}

              {!loading && rows.length === 0 && (
                <Paper sx={{ p: 3, textAlign: 'center' }}>
                  <Typography color="text.secondary">No task progress records found.</Typography>
                </Paper>
              )}
            </Stack>
          </Grid>

          <Grid size = {{ xs:12, md:5}}>
            <Paper elevation={1} sx={{ p: 2, position: 'sticky', top: 16 }}>
              {/* <TaskInspector task={selected} onChanged={this.load}/> */}
              <TaskInspector
                task={selected}
                tab={this.state.inspectorTab}
                onTabChange={(tab) => this.setState({ inspectorTab: tab })}
                onChanged={this.load}
              />
              {/* {selected ? (
                <Stack spacing={2}>
                  <Box>
                    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                      <Typography variant="subtitle1" sx={{ flex: 1 }}>
                        Selected Task
                      </Typography>
                      <Chip size="small" label={selected.ssc || 'State'} />
                    </Stack>

                    <Typography variant="body2" color="text.secondary">
                      {selected.tkc}
                    </Typography>

                    <Typography variant="h6" sx={{ mb: 1 }}>
                      {selected.tkn}
                    </Typography>

                    <Typography variant="body2">
                      Activity: <b>{selected.atn}</b>
                    </Typography>

                    <Typography variant="body2">
                      Reported: <b>{selected.rpr}%</b>
                    </Typography>

                    <Typography variant="body2">
                      Approved: <b>{selected.apr}%</b>
                    </Typography>
                  </Box>

                  <ProgressApprovalPanel
                    task={selected}
                    onChanged={this.load}
                  />

                  <ProgressEvidencePanel
                    task={selected}
                    onChanged={this.load}
                  />

                  <TaskActionTimeline
                    task={selected}
                    onChanged={this.load}
                  />
                </Stack>
              ) : (
                <Typography color="text.secondary">Select a task to view details.</Typography>
              )} */}
            </Paper>
          </Grid>
        </Grid>
      </Box>
    );
  }
}